import { ErrorBoundary } from '@/components/shell/ErrorBoundary';

import { workspace } from '../controller';
import { useWorkspaceStore } from '../store';
import { PanelContent } from '../content/PanelContent';

/**
 * Shared inner content for a panel in any mode (tabbed/floating/maximized).
 * Panels render the REAL surfaces (GraphTab/OrbitTab/ReaderTab/…), each
 * owning its own padding/scroll/canvas sizing — this must stay a bare,
 * edge-to-edge frame, never the old read-only "workview pane" padding.
 *
 * The per-panel ErrorBoundary is what keeps one bad document from
 * white-screening the whole studio: a render throw in one panel's surface is
 * caught here (not by the shell-level AppErrorBoundary), degrading to a single
 * recoverable tab that offers both "Try again" and "Close panel". Reset-keyed
 * on `panelId` so a boundary that failed for one panel starts clean if the
 * dock ever reuses this slot for a different panel.
 */
export function PanelBody({ panelId }: { panelId: string }) {
  const exists = useWorkspaceStore((s) => !!s.panels[panelId]);
  if (!exists) return null;
  return (
    <div className="wp-panel-fill">
      <ErrorBoundary
        label="panel"
        resetKey={panelId}
        action={{ label: 'Close panel', onClick: () => workspace.closePanel(panelId) }}
      >
        <PanelContent panelId={panelId} />
      </ErrorBoundary>
    </div>
  );
}
